import React from 'react'
import { NavLink, Link } from 'react-router-dom';
import { esSesionAdmin } from '../usuario/Usuario';
import BreadCrumComponent from './BreadCrumComponent';
import { verificarRol, gestionTramites, gestionLegajos } from '../../constans/constants';

class NavbarConfiguraciones extends React.Component {

    verificarRoles = (rolAVerificar) => {
        const rolesData = JSON.parse(localStorage.getItem("roles"));
        return verificarRol(rolesData, esSesionAdmin() ? "admin" : rolAVerificar)
    }

    render() {
        const {
            titulo,
            descripcion,
            textoBoton,
            direccionBoton
        } = this.props;

        return (
            <header className="component-header">
                <div className="page-container">
                    <BreadCrumComponent
                        backUrl='/bandeja/pendientes'
                        breadcrumbs={
                            [
                                { label: 'Configuraciones', path: '' }
                            ]
                        }
                    />

                    {/* Área de navegación */}
                    <nav className="nav-area">
                        <NavLink to="/configuracion/tipo-documento" className="nav-link">
                            <span className="material-symbols-outlined">library_books</span> Tipos de documentos
                        </NavLink>
                        {
                            this.verificarRoles(gestionTramites) &&

                            <NavLink to="/configuracion/tipo-solicitud" className="nav-link">
                                <span className="material-symbols-outlined">fork_right</span> Tipos de solicitudes
                            </NavLink>
                        }

                        <NavLink to="/configuracion/aplicaciones-externas" className="nav-link">
                            <span className="material-symbols-outlined">widgets</span> Aplicaciones Externas
                        </NavLink>
                        <NavLink to="/configuracion/numero-patronal" className="nav-link">
                            <span className="material-symbols-outlined">co_present</span> Número de MTESS Patronal
                        </NavLink>
                        <NavLink to="/configuracion/plantilla-correo" className="nav-link">
                            <span className="material-symbols-outlined">mail</span> Plantillas de Correo
                        </NavLink>
                        {
                            this.verificarRoles(gestionLegajos) &&
                            <NavLink to="/configuracion/feriados" className="nav-link">
                                <span className="material-symbols-outlined">event</span> Feriados
                            </NavLink>
                        }
                    </nav>

                    <div className="head-area">
                        <div className="caption-area">
                            <h1 className="page-title">{titulo}</h1>
                            <p className="page-description">{descripcion}</p>
                        </div>
                        {
                            textoBoton &&
                            <div className="head-actions">
                                <Link to={direccionBoton} className="btn-medium btn-primary">
                                    {textoBoton}
                                </Link>
                            </div>
                        }

                    </div>

                </div>
            </header>
        );
    }
}

export default NavbarConfiguraciones;
